import React, { useEffect, useRef, useState } from 'react';
import SearchAndAddItem from '../../components/common/TableData';
import AdminDataTable from '../../components/common/AdminDataTable';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toastEmitter } from '../../../utills/utilities';
import { API_RESPONSE } from '../../../utills/app-constant';
import { AssessoractiveInactive, deleteCampaignById, deleteCompanyAssessorById, deleteModalById, getAllAssignedEmployee, getAllCompanies, getAssessorsEmployeeList, getAssessorsList } from '../../../services/api-services';
import { ROUTES } from '../../routes/url-constant';
import AccessPermissionpage from './AccessPermissionpage';
import TableHeading from '../../components/common/TableHeading';
import moment from 'moment';
import { ACTIONARROW_ICON, DELETE_ICON, EDIT_ICON, RIGHTARROW_ICON } from '../../../utills/image-constant';
import DeleteModal from '../../components/common/DeleteModal';

const AssessorList = () => {
    const DeleteModalRef = useRef()
    const [pending, setPending] = useState(false);
    const [loading, setLoading] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [searchText, setSearchText] = useState("");
    const [sortColumn, setSortColumn] = useState("id");
    const [sortDirection, setSortDirection] = useState("desc");
    const [permissionAccess, setPermissionAccess] = useState();
    const [companyList, setCompanyList] = useState([]);
    const [selectedCompanyId, setSelectedCompanyId] = useState(localStorage.getItem("ViewAssesmentCompanyId") || ""); // Store selected company
    const [totalElement, settotalElement] = useState();
    
    const { value } = useSelector((state) => state?.adminRole);
    const [deleteCampaignId, setDeleteCampaignId] = useState(null);
    const [deleteCampaignName, setDeleteCampaignName] = useState('');
    const navigate = useNavigate();

    // Retrieve the company ID from local storage
    let viewAssComapnyId = localStorage.getItem("ViewAssesmentCompanyId");
    useEffect(() => {
        const RoleAccessFilterData =
            value && value.filter((v) => v?.moduleName === "Campaign Management");
        setPermissionAccess(RoleAccessFilterData?.[0]);
    }, [value]);

    // Fetch assigned employee data by computing the payload inline
    const getAssessorsLists = async () => {
        console.log('sortDirection',sortDirection);
        
        setPending(true);
        setLoading(true);
        const currentPayload = {
            filterByFieldName: sortColumn,
            direction: sortDirection,
            pageSize: pageSize,
            pageIndex: page,
            searchText: searchText,
            companyId: viewAssComapnyId ? viewAssComapnyId : selectedCompanyId || "",
            employeeList: []
        };
        try {
            const response = await getAssessorsEmployeeList(currentPayload);
            console.log('response-------------',response);
            
            if (response?.data?.responseCode === 404) {
                setRowData([]);
            } else if (response?.data?.responseCode === 200) {
                const res = response?.data?.data?.companyAssessorResponseList;
                setRowData(res);
                settotalElement(response?.data?.data?.totalElement);
            } else {
                toastEmitter("error", response?.data?.message);
            }
        } catch (err) {
            toastEmitter("error", API_RESPONSE.MESSAGE_503);
        } finally {
            setPending(false);
            setLoading(false);
        }
    };

    // Trigger data fetch when any dependency changes
    useEffect(() => {
        getAssessorsLists();
    }, [page, pageSize, sortColumn, sortDirection, selectedCompanyId, viewAssComapnyId, searchText]);


    // Fetch the list of companies
    const getallCompany = async () => {
        setPending(true);
        try {
            const response = await getAllCompanies();
            if (response?.data?.responseCode === 404) {
                setCompanyList([]);
            } else if (response?.data?.responseCode === 200) {
                const companyOptions = response?.data?.responseBody.map((data) => ({
                    value: data?.id,
                    label: data?.companyName,
                    Status: data?.status,
                }));
                setCompanyList(companyOptions);
            } else {
                toastEmitter("error", response?.data?.message);
            }
        } catch (err) {
            toastEmitter("error", API_RESPONSE.MESSAGE_503);
        } finally {
            setPending(false);
        }
    };

    useEffect(() => {
        getallCompany();
    }, []);

    const handleModelSearchChange = (e) => {

        setSearchText(e.target.value);
    };

    const handleSelect = (event) => {
        const selectedValue = event.target.value;
        setSelectedCompanyId(selectedValue);
        if (selectedValue === "") {
            localStorage.removeItem("ViewAssesmentCompanyId");
        } else {
            localStorage.setItem("ViewAssesmentCompanyId", selectedValue);
        }
    };

    const handleClearFilter = () => {
        setSelectedCompanyId("");
        localStorage.removeItem("ViewAssesmentCompanyId");
    };

    const addButtonClick = () => {
        navigate(ROUTES.ADDASSESSORMANAGEMENT, {
            state: { Data: rowData },
        });
    };


    const tableCustomStyles = {
        headRow: {
            style: {
                color: "#1B2128",
                fontSize: "14px",
            },
        },
        rows: {
            style: {
                color: "#1B2128",
                fontSize: "14px",
                paddingTop: "10px",
            },
        },
    };

    const deleteButtonClick = (id,name) => {
        setDeleteCampaignId(id)
        setDeleteCampaignName(name)
        DeleteModalRef.current.click();
    }


  const handleStatusChange = async (row) => {
    const newStatus = row?.status === 1 ? 0 : 1; // Toggle the status

    const updatedRowData = rowData.map((item) =>
      item.id === row.id ? { ...item, status: newStatus } : item
    );
    setRowData(updatedRowData); // Update local state with the new status

    try {
      let response = await AssessoractiveInactive(row.id, newStatus);

      if (response?.data?.responseCode === 200) {
        toastEmitter("success", response?.data?.message);
      } else {
        // If the API fails, revert the status in local state
        const revertRowData = rowData.map((item) =>
          item.id === row.id ? { ...item, status: row?.status } : item
        );
        setRowData(revertRowData);
        console.error("Failed to update model status");
      }
    } catch (error) {
      // If there's an error, revert the status in local state
      const revertRowData = rowData.map((item) =>
        item.id === row.id ? { ...item, status: row?.status } : item
      );
      setRowData(revertRowData);
      console.error("Error during status change:", error);
    }
  };

    const tblColumns = [
        {
            code: "Action",
            name: "Action",
            width: "120px",
            sortable: false,
            cell: (row) => (
                <div>
                    <button
                        className="border-0 bg-white"
                        onClick={() =>
                            navigate(ROUTES.ADDASSESSORMANAGEMENT, {
                                state: { pageType: "Edit", Data: row },
                            })
                        }
                    >
                        <img src={EDIT_ICON} alt="Edit" className="editicon" />
                    </button>
                    <span>
                        <button
                            className="border-0 bg-white ms-2"
                            onClick={() =>
                                navigate(ROUTES.ADDASSESSORMANAGEMENT, {
                                    state: { pageType: "View", Data: row },
                                })
                            }
                        >
                            <img src={ACTIONARROW_ICON} alt="Action" className="editicon" />
                        </button>
                    </span>
                    <span>
                        <button
                            className="border-0 bg-white"
                            onClick={() => deleteButtonClick(row?.id,row?.adminResponsePayload?.name)}
                        >  <img src={DELETE_ICON} alt="View" className="editicon ms-2" />
                        </button>
                    </span>
                </div>
            ),
        },
        {
            code: "name",
            name: "Assessor Name",
            width: "200px",
            sortable: true,
            selector: (row) => (
                <div className="table-cell-content">{row?.adminResponsePayload?.name}</div>
            ),
        },
        {
            code: "email",
            name: "Assessor Email",
            width: "180px",
            sortable: true,
            selector: (row) => (
                <div className="table-cell-content">{row?.adminResponsePayload?.email}</div>
            ),
        },
        {
            code: "companyName",
            name: "Company",
            width: "180px",
            sortable: true,
            selector: (row) => (
                <div className="table-cell-content">{row?.companyResponse?.companyName}</div>
            ),
        },
        {
            code: "departmentName",
            name: "Department",
            width: "160px",
            sortable: true,
            selector: (row) => (
                <div className="table-cell-content">{row?.department?.departmentName}</div>
            ),
        },
        {
            code: "totalAssignEmployee",
            name: "Hierarchy",
             width: "120px",
            sortable: false,
            selector: (row) => (
                <div className="table-cell-content">{row?.hierarchy?.hierarchyName}</div>
            ),
        },
        {
            code: "status",
            name: "Status",
            // width: "180px",
            omit: false,
            sortable: true,
            cell: (row) => (
                <div className="form-switch-btn">
                    <label className="switch">
                        <input
                            disabled={permissionAccess?.moduleAction === 0}
                            type="checkbox"
                            id="togBtn"
                            checked={row?.status === 1}
                            onChange={() => handleStatusChange(row)}
                        />
                        <div className="slider round">
                            {row?.status === 1 ? (
                                <span className="on">Active</span>
                            ) : (
                                <span className="off">Inactive</span>
                            )}
                        </div>
                    </label>
                </div>
            ),
        }
    ];

    const handleModalDelete = async () => {
        console.log("response------------", deleteCampaignId);
        try {
            const response = await deleteCompanyAssessorById(deleteCampaignId);
            if (response?.data?.responseCode === 200) {
                toastEmitter('success', response.data.message);
                getAssessorsLists();
            } else {
                toastEmitter('error', response.data.message || API_RESPONSE?.MESSAGE_500)
            }
        } catch (err) {

        }
    }

    return (
        <>
            {permissionAccess?.addAction === 0 &&
                permissionAccess?.updateAction === 0 &&
                permissionAccess?.viewAction === 0 ? (
                <AccessPermissionpage />
            ) : (
                <div className="modal_datatable">
                    <TableHeading firstData="Customer Management" icon={RIGHTARROW_ICON} secondData="Assessor Management" />
                    <div className="container-fluid">
                        <div className="caspera_admin_datatable mb-3">
                            <SearchAndAddItem
                                searchValue={searchText}
                                onSearchChange={handleModelSearchChange}
                                addButtonClick={addButtonClick}
                                data="Assessor"
                                permissionAccessbtn={permissionAccess?.addAction}
                                labelName="Select Company"
                                lableclassName="addInput-label"
                                name="companyId"
                                options={companyList}
                                className="form-control addInputText-lable"
                                handleSelect={handleSelect}
                                value={viewAssComapnyId ? viewAssComapnyId : selectedCompanyId}
                                showDropdown={true}
                                clearbtn={true}
                                handleClear={handleClearFilter}
                            />

                            <AdminDataTable
                                _tblColumns={tblColumns}
                                _rowData={rowData}
                                tableCustomStyles={tableCustomStyles}
                                pending={pending}
                                setPending={setPending}
                                _totalRows={totalElement}
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                setPage={setPage}
                                setSortColumn={setSortColumn}
                                setSortDirection={setSortDirection}
                            />
                        </div>
                    </div>
                    <DeleteModal
                        DeleteModalRef={DeleteModalRef}
                        title="Assessor"
                        handleDelete={handleModalDelete}
                        name= {deleteCampaignName}
                    />
                </div>
            )}

        </>
    );
};

export default AssessorList;
